import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { removeAll } from '../../hooks/hooks.localStorage';
import { Clock, LogOut, RefreshCw } from 'lucide-react';

export default function PendingApproval() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(s => s.userReducer.user);

  const handleLogout = () => {
    dispatch({ type: 'logout' });
    removeAll();
    navigate('/login');
  };

  const handleRefresh = () => {
    // Re-check by reloading — they should re-login after approval to get new token
    window.location.reload();
  };

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: 480, textAlign: 'center' }}>
        {/* Animated clock icon */}
        <div style={{
          width: 80, height: 80, borderRadius: '50%',
          background: 'linear-gradient(135deg, var(--primary-glow), var(--bg-card))',
          border: '2px solid var(--primary)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 24px',
          animation: 'pulse 2s ease-in-out infinite',
        }}>
          <Clock size={36} color="var(--primary)" />
        </div>

        <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 8 }}>
          En attente d'approbation
        </h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', marginBottom: 24, lineHeight: 1.6 }}>
          Bonjour <strong style={{ color: 'var(--text-primary)' }}>{user?.prenom} {user?.nom}</strong> 👋<br />
          Votre compte est en attente d'approbation par l'investisseur de votre entreprise.
          Une fois approuvé, déconnectez-vous et reconnectez-vous pour accéder à vos données.
        </p>

        <div style={{
          background: 'var(--bg-input)', borderRadius: 'var(--radius)',
          padding: '14px 18px', marginBottom: 28,
          display: 'flex', alignItems: 'center', gap: 10,
          border: '1px solid var(--border)',
        }}>
          <div style={{
            width: 8, height: 8, borderRadius: '50%',
            background: '#f59e0b', flexShrink: 0,
            boxShadow: '0 0 8px #f59e0b',
            animation: 'pulse 1.5s ease-in-out infinite',
          }} />
          <span style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
            Statut : <strong>En attente</strong>
          </span>
        </div>

        <div style={{ display: 'flex', gap: 12 }}>
          <button
            className="btn btn-outline"
            onClick={handleRefresh}
            style={{ flex: 1, gap: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <RefreshCw size={15} /> Actualiser
          </button>
          <button
            className="btn btn-primary"
            onClick={handleLogout}
            style={{ flex: 1, gap: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <LogOut size={15} /> Se déconnecter
          </button>
        </div>
      </div>
    </div>
  );
}
